import type { BetPrices } from '@mobi/betslip/types'

export function shouldShowPriceChangeMessage(current: BetPrices, newPrices: BetPrices): boolean {
  if (newPrices.winPrice && current.winPrice && newPrices.winPrice < current.winPrice) {
    return true
  }

  if (newPrices.placePrice && current.placePrice && newPrices.placePrice < current.placePrice) {
    return true
  }

  return false
}
